import { useState } from 'react'
import { getGallery, removeFromGallery } from './utils/galleryStorage'
import { IconClose, IconDownload, IconDelete } from './components/Icons'
import './Gallery.css'

export function Gallery({ items, onClose, onItemsChange, onOpenForEdit, lang = 'he' }) {
  const [lightboxId, setLightboxId] = useState(null)

  const handleOpenForEdit = (e, item) => {
    e.stopPropagation()
    onOpenForEdit?.(item)
    onClose?.()
  }

  const handleRemove = (e, id) => {
    e.stopPropagation()
    const ok = window.confirm(lang === 'en' ? 'Delete this image from gallery?' : 'למחוק את התמונה מהגלריה?')
    if (!ok) return
    removeFromGallery(id)
    onItemsChange?.()
    if (lightboxId === id) setLightboxId(null)
  }

  const handleDownload = (e, item) => {
    e.stopPropagation()
    const link = document.createElement('a')
    link.download = `${item.name || 'coloring'}.png`
    link.href = item.dataUrl
    link.click()
  }

  const lightboxItem = lightboxId ? items.find((i) => i.id === lightboxId) : null

  return (
    <div className="gallery-modal" role="dialog" aria-label={lang === 'en' ? 'Gallery' : 'גלריה'}>
      <div className="gallery-header">
        <h2>{lang === 'en' ? 'Gallery' : 'גלריה'}</h2>
        <button type="button" className="gallery-close" onClick={onClose} aria-label={lang === 'en' ? 'Close' : 'סגור'}>
          <IconClose size={22} />
        </button>
      </div>
      <div className="gallery-body">
        {items.length === 0 ? (
          <p className="gallery-empty">{lang === 'en' ? 'No images yet. Save a drawing to see it here.' : 'אין עדיין תמונות בגלריה. שמור ציור מהעבודה הנוכחית.'}</p>
        ) : (
          <div className="gallery-grid">
            {items.map((item) => (
              <div
                key={item.id}
                className="gallery-card"
                onClick={() => setLightboxId(item.id)}
              >
                <img src={item.dataUrl} alt={item.name} className="gallery-thumb" />
                <span className="gallery-card-name">{item.name}</span>
                <div className="gallery-card-actions">
                  {onOpenForEdit && (
                    <button
                      type="button"
                      className="gallery-btn gallery-btn-edit"
                      onClick={(e) => handleOpenForEdit(e, item)}
                      title={lang === 'en' ? 'Continue editing' : 'המשך לערוך'}
                    >
                      ✏️
                    </button>
                  )}
                  <button
                    type="button"
                    className="gallery-btn gallery-btn-download"
                    onClick={(e) => handleDownload(e, item)}
                    title={lang === 'en' ? 'Download' : 'הורד'}
                  >
                    <IconDownload size={18} />
                  </button>
                  <button
                    type="button"
                    className="gallery-btn gallery-btn-delete"
                    onClick={(e) => handleRemove(e, item.id)}
                    title={lang === 'en' ? 'Delete' : 'מחק'}
                  >
                    <IconDelete size={18} />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {lightboxItem && (
        <div
          className="gallery-lightbox"
          onClick={() => setLightboxId(null)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === 'Escape' && setLightboxId(null)}
          aria-label={lang === 'en' ? 'Close preview' : 'סגור תצוגה'}
        >
          <img
            src={lightboxItem.dataUrl}
            alt={lightboxItem.name}
            onClick={(e) => e.stopPropagation()}
          />
          <div className="gallery-lightbox-actions">
            {onOpenForEdit && (
              <button type="button" className="gallery-btn-edit" onClick={(e) => handleOpenForEdit(e, lightboxItem)}>
                {lang === 'en' ? '✏️ Continue editing' : '✏️ המשך לערוך'}
              </button>
            )}
            <button type="button" onClick={(e) => handleDownload(e, lightboxItem)}>
              {lang === 'en' ? 'Download image' : 'הורד תמונה'}
            </button>
            <button type="button" className="gallery-btn-delete" onClick={(e) => handleRemove(e, lightboxItem.id)}>
              {lang === 'en' ? 'Delete' : 'מחק'}
            </button>
          </div>
        </div>
      )}
    </div>
  )
}
